import { Row, Col, Table, Tooltip, Tag } from 'antd';

import IconNotFound from '../../../assets/Images/icons/empty';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DataBreachService from '../../../services/DataBreach.service';
import UserService from '../../../services/UserService';
import { ROUTER } from '../../../constants/router';
import usePermission from '../../../hooks/usePermission';
import classNames from 'classnames';

const ResponsibilityList = () => {
    const { t } = useTranslation('data-breach');

    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 'dataBreachName',
        sd: 'ASC',
    });
    const [loading, setLoading] = useState(0);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (loading === 0) {
            getResponsibilityList(currentPage);
            setLoading(1);
        }
    }, [currentPage, loading]);

    const getResponsibilityList = (pageValue) => {
        const payload = {
            p: pageValue.page || 1,
            ps: pageValue.pageSize || 10,
            s: pageValue.sortBy || 'dataBreachName',
            sd: pageValue.sortDirection || 'asc',
        };
        DataBreachService.getResponsibilityList(payload).then((res) => {
            setData(res?.data?.resultData?.result || []);
            setCurrentPage({
                page: res?.data?.resultData.page,
                pageSize: res?.data?.resultData.pageSize,
                total: res?.data?.resultData.total,
            });
        });
    };

    const { isAuditor, isUser } = usePermission();

    const columns = [
        {
            title: t('Name'),
            dataIndex: 'dataBreachName',
            key: 'dataBreachName',
            sorter: () => null,
            render: (value, record) => {
                return (
                    <div className="space-y-1">
                        <div className="text-[#1E1E1E] font-normal text-sm">
                            {record.dataBreachName}
                        </div>
                    </div>
                );
            },
        },
        {
            title: t('Responsible person'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (status, record) => (
                <>
                    {status === 'รอการตั้งค่า' ? (
                        <Tag className="rounded-xl -my-1 text-center bg-[#F9C153] border-[#F9C153] text-white">
                            {t('Waiting for configuration')}
                        </Tag>
                    ) : (
                        <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white">
                            {t('Complete')}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: t('Modify date'),
            dataIndex: 'modify_date',
            key: 'modify_date',
            sorter: true,
            render: (modify_date, record) => (
                <>
                    {record.modifyDate ? (
                        <div className="text-[#1E1E1E] font-normal text-sm">
                            <p>{record.modifyDate}</p>
                            <p>{record.modifyBy}</p>
                        </div>
                    ) : (
                        '-'
                    )}
                </>
            ),
        },
        {
            title: t('Edit action'),
            key: 'action',
            align: 'center',
            width: 200,
            render: (text, record) => (
                <span className="space-x-2">
                    <Tooltip
                        placement="bottom"
                        title={t('Edit')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <button
                            disabled={isAuditor || isUser}
                            onClick={() =>
                                navigate(
                                    `${ROUTER.DATA_BREACH.RESPONSIBILITY_FORM}/${record.dataBreachGroupId}`
                                )
                            }
                            className="disabled:cursor-not-allowed"
                        >
                            <svg
                                className={classNames({
                                    'opacity-50': isAuditor || isUser,
                                })}
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="32"
                                    height="32"
                                    rx="6"
                                    fill="#F3F6F9"
                                />
                                <path
                                    d="M20.6586 9.34131L22.6586 11.3413L21.1339 12.8666L19.1339 10.8666L20.6586 9.34131ZM13.3333 18.6666H15.3333L20.1913 13.8086L18.1913 11.8086L13.3333 16.6666V18.6666Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </button>
                    </Tooltip>
                </span>
            ),
        },
    ].filter((item) => !item.hidden);

    const paginationProps = {
        current: parseInt(currentPage.page),
        total: parseInt(currentPage.total),
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy:
                sorter && sorter.order ? sorter.columnKey : 'dataBreachName',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'asc',
            //   total: pageValue.total,
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        getResponsibilityList(pageValues);
    };

    return (
        <div className="bg-gray-body ">
            <div className="title flex">{t('Responsibility')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Breach')} / {t('Responsibility')}
                </span>
            </div>
            <div className="w-full m-auto">
                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Row>
                            <Col span={21}>
                                <Row>
                                    <div className="title ">
                                        {t(
                                            'Assign a responsible person to Data Breach form'
                                        )}
                                    </div>
                                </Row>
                                <Row>
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-400">
                                            {t(
                                                'Assign responsible persons for each step. When reporting a personal data breach'
                                            )}
                                        </span>
                                    </div>
                                </Row>
                                <Row className="my-4">
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-500 font-semibold">
                                            {t('TotalItems', {
                                                length: currentPage.total,
                                            })}
                                        </span>
                                    </div>
                                </Row>
                            </Col>
                        </Row>

                        <Table
                            locale={{ emptyText: <IconNotFound /> }}
                            className="inbox_table"
                            rowKey={(record, i) => record.id + i}
                            //loading={loading}
                            columns={columns}
                            dataSource={data}
                            pagination={paginationProps}
                            onChange={onPageChange}
                        />
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
    );
};

export default ResponsibilityList;
